import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-checkbox" }
const _hoisted_2 = { class: "base-checkbox--label" }
const _hoisted_3 = { class: "caption-small" }


import { useI18n } from "vue-i18n";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

function toggle() {
  emit("update:modelValue", !props.modelValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["base-checkbox--box", { active: _ctx.modelValue }]),
      onClick: toggle
    }, [
      _createVNode(BaseFigureForIcon, {
        icon: "check-checkbox",
        color: "primary",
        size: "small",
        radius: "1px",
        class: "base-checkbox--box-icon"
      })
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("base.checkbox.consent")), 1)
    ])
  ]))
}
}

})